import { Link } from 'react-router-dom';
import { Icon } from './Icon';
import { useDesktopPresence } from '../lib/desktopPresence';

/**
 * تنبيهٌ يظهر حين يُفتح النظامُ في المتصفّح دون أن يكون التطبيقُ مثبَّتًا.
 *
 * من ثبّت التطبيقَ لا يُدعى إلى تنزيله ثانيةً — يُكتفى منه بأنّه نشطٌ على
 * الجهاز، فلا يظهر التنبيه. ومن لم يثبّته يُدعى إليه دون منعٍ من المتصفّح،
 * فهو بديلٌ يعمل.
 */
export function DesktopAppNotice({ context }: { context: 'call' | 'monitor' }) {
  const { active, ready } = useDesktopPresence();
  /* لا يظهر إلّا بعد التأكّد أنّ التطبيقَ غيرُ نشطٍ على الجهاز. */
  if (!ready || active) return null;

  const text =
    context === 'call'
      ? 'أنت تعمل من المتصفّح. لمكالماتٍ من الهاتف المقترن مباشرةً وتسجيلٍ بلا إعادة سؤالٍ كلَّ مرّة، شغّل النظام من تطبيق سطح المكتب.'
      : 'أنت تعمل من المتصفّح. لالتقاطٍ من نافذة النظام وحدها وموافقةٍ واحدةٍ تُحفظ على الجهاز، شغّل المراقبة من تطبيق سطح المكتب.';

  return (
    <div className="alert alert-info mb-4">
      <Icon name="video" size={16} />
      <div>
        {text} <Link to="/settings/desktop-app">تنزيل التطبيق</Link>
      </div>
    </div>
  );
}
